import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

function CardSkeleton() {
  return (
    <Paper sx={{ p: 2, height: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Skeleton width={100} height={20} />
        <Skeleton variant="circular" width={24} height={24} />
      </Box>
      <Skeleton width={80} height={40} />
      <Skeleton width={60} height={16} sx={{ mt: 1 }} />
    </Paper>
  );
}

export function DashboardSkeleton() {
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box>
          <Skeleton width={280} height={40} />
          <Skeleton width={220} height={20} />
        </Box>
        <Skeleton width={160} height={36} variant="rounded" />
      </Box>

      {/* Metric Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {[0, 1, 2, 3].map((i) => (
          <Grid key={i} size={{ xs: 12, sm: 6, md: 3 }}>
            <CardSkeleton />
          </Grid>
        ))}
      </Grid>

      {/* Charts + Activity Row */}
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Paper sx={{ p: 3 }}>
            <Skeleton width={120} height={28} sx={{ mb: 2 }} />
            <Skeleton variant="rectangular" height={300} />
          </Paper>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Paper sx={{ p: 3, height: "100%" }}>
            <Skeleton width={140} height={28} sx={{ mb: 2 }} />
            {[0, 1, 2, 3, 4].map((i) => (
              <Skeleton key={i} height={48} sx={{ mb: 0.5 }} />
            ))}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
